var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobile)?_c('div',[_vm._t("mobile")],2):_c('div',[_vm._t("desktop")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }